import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { defineStore, storeToRefs } from 'pinia';
import { useEditor } from '@/stores/editor/editor';
import { shareableInsights } from '@/helpers/constants/shareableInsights';

export const useSharePage = defineStore('sharePageStore', () => {
  const route = useRoute();

  const { isSharePage } = storeToRefs(useEditor());

  const isReportingSharePage = computed(() => shareableInsights.includes(route.name)
        && window.sessionStorage.reportingShareKey);

  const isNotSharePage = computed(() => !(isSharePage.value
    || window.sessionStorage.shareKey || isReportingSharePage.value));

  return {
    isNotSharePage,
  };
});
